export const initialState = {
  actionProcessing: false,

  financeHistory: {
    transfers: [],
    details: {
      totalCount: 0,
    },
  },

  flatPages: [],
};
